module.exports = __webpack_public_path__ + "img/delete.3d366562.svg";